import React from "react";
import "./_styles.scss";

interface IPropsCheckbox {
  label?: string,
  size: string,
  name: string,
  checked?: boolean,
  id: string,
  onChange?: (ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
}

const Checkbox = (props: IPropsCheckbox) => {
  return (
    <div className="wrapper-checkbox">
      <input
        type="checkbox"
        name={props.name}
        onChange={props.onChange}
        checked={props.checked}
        id={props.id}
      />
      <label htmlFor={props.id} className={`label label--${props.size}`}>{props.label}</label>
    </div>
  )
}

export default Checkbox